import React from 'react';

const Careers: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 dark:from-gray-900 dark:to-gray-800 py-12" dir="ltr">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6 text-center">Careers at PingQuack Inc.</h1>
        <section className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-orange-600 mb-4">About PingQuack Inc.</h2>
          <p className="mb-6">PingQuack Inc. is a creative technology company developing culturally enriching digital products. I’ve recently completed development on an educational app tailored to the Persian-speaking community in the U.S. and am now seeking QA support for final validation.</p>
          <h2 className="text-2xl font-semibold text-orange-600 mb-4">Position Overview</h2>
          <p className="mb-6">I am hiring <strong>two QA Developers</strong> on a <strong>short-term contract basis</strong> to test and validate a completed mobile/web application. This role is fully remote, pays <strong>$50/hour</strong>, and requires approximately <strong>30 hours of total work</strong>. Candidates should also be open to full-time employment in the future if a longer-term role becomes available. Any full-time opportunity will be discussed with updated compensation and benefits at that time.</p>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">Responsibilities:</h3>
          <ul className="list-disc pl-6 mb-6 text-gray-700 dark:text-gray-200">
            <li>Conduct manual and exploratory QA testing on the completed app</li>
            <li>Log and manage issues using <strong>JIRA</strong></li>
            <li>Validate UI consistency, responsiveness, and user flows across devices</li>
            <li>Collaborate briefly with the development team to confirm fixes</li>
            <li>Submit a final QA report summarizing findings and user-impact observations</li>
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">Requirements:</h3>
          <ul className="list-disc pl-6 mb-6 text-gray-700 dark:text-gray-200">
            <li>Proficiency with JIRA in previous companies or client projects</li>
            <li>Demonstrated experience in testing mobile/web applications</li>
            <li>Studied UX design or strong understanding of user experience principles</li>
            <li><strong>Fluency in Farsi is required</strong> – please do not apply if you do not speak Farsi</li>
            <li>Persian descent preferred due to the cultural context of the app</li>
            <li><strong>U.S. Citizenship is required</strong> – please do not apply if you are a green card holder</li>
            <li>Must be open to full-time employment if a future opportunity becomes available</li>
            <li>Detail-oriented, user-focused, and able to work independently</li>
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">Compensation & Terms:</h3>
          <ul className="list-disc pl-6 mb-6 text-gray-700 dark:text-gray-200">
            <li>Contract Position</li>
            <li>$50/hour</li>
            <li>Approximately 30 hours of work</li>
            <li>Remote and flexible schedule</li>
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">Interview Process:</h3>
          <ul className="list-disc pl-6 mb-6 text-gray-700 dark:text-gray-200">
            <li>One 1-hour interview</li>
            <li>All hiring decisions will be finalized by <strong>August 15th</strong></li>
          </ul>
          <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">To Apply:</h3>
          <p className="mb-2">Please send your <strong>resume</strong> and <strong>your availability for a 1-hour interview</strong> to:</p>
          <p className="text-lg font-bold text-orange-700 select-all">📧 support@pingquack.com</p>
        </section>
      </div>
    </div>
  );
};

export default Careers; 